let baseURL = process.env.REACT_APP_API_URL

export const config = {  
  "BASE_URL": baseURL,  
  "API_URL": baseURL + "/api/v1",    
  "MEDIA_URL": baseURL + "/media",
  "APP_NAME": "PGKPL",
  "APP_VERSION": "1.0.0"
}